import { render, staticRenderFns } from "./RiskProfiles.vue?vue&type=template&id=29602b7b&scoped=true&"
import script from "./RiskProfiles.vue?vue&type=script&lang=js&"
export * from "./RiskProfiles.vue?vue&type=script&lang=js&"
import style0 from "./RiskProfiles.vue?vue&type=style&index=0&id=29602b7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29602b7b",
  null
  
)

export default component.exports